import React, { useState } from "react";
import { 
  MessageSquare, 
  Send, 
  Sparkles, 
  Bell, 
  User, 
  CheckCircle2 
} from "lucide-react";
import { toast } from "sonner";

export const LodgeMessagesView = ({
  currentUser
}) => {
  const [messages, setMessages] = useState([
    {
      id: "msg_01",
      sender: "Venerável Mestre Ir. Roberto Drummond",
      role: "Master da Loja",
      date: "Hoje às 14:30",
      content: "Meus queridos Irmãos, informamos que a próxima Sessão Magna de Elevação contará com a ilustre visita da comitiva da Potência. Pedimos traje a rigor completo (Terno preto, gravata preta e paramentos do grau).",
      important: true
    },
    {
      id: "msg_02",
      sender: "Tesouraria (Ir. Fernando)",
      role: "Tesouraria",
      date: "Ontem às 10:15",
      content: "Lembramos a todos os Irmãos que o vencimento da capitação mensal com desconto de pontualidade é até o dia 10. Aproveite a facilidade de quitação via PIX no seu Extrato Individual.",
      important: false
    },
    {
      id: "msg_03",
      sender: "Hospitalaria (Ir. Dr. Guilherme)",
      role: "Hospitalaria",
      date: "02 de Junho",
      content: "Agradecemos o generoso giro do Tronco de Beneficência no valor de R$ 1.250,00 no Banquete do Solstício. Todos os recursos já foram convertidos em cestas para o Asilo São Vicente.",
      important: false
    }
  ]);

  const [newMessage, setNewMessage] = useState("");

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    const doc = {
      id: `msg_${Date.now()}`,
      sender: currentUser?.name || "Irmão do Quadro",
      role: currentUser?.office || "Membro",
      date: "Agora",
      content: newMessage.trim(),
      important: false
    };

    setMessages([doc, ...messages]);
    setNewMessage("");
    toast.success("Mensagem publicada no mural da Loja com sucesso!");
  };

  return (
    <div className="space-y-6" data-testid="lodge-messages-view">
      
      <div>
        <h2 className="text-2xl font-serif font-bold text-white">Quadro de Avisos & Mensagens Fraternais</h2>
        <p className="text-xs text-slate-400">
          Comunicações oficiais da Diretoria, convocações e informes aos Irmãos do Quadro
        </p>
      </div>

      {/* Post a message box */}
      <form onSubmit={handleSendMessage} className="luxury-card p-4 space-y-3">
        <label className="block text-xs font-semibold text-[#D4AF37] uppercase tracking-wider">
          Publicar Aviso no Mural da Loja
        </label>
        <textarea
          rows="2"
          placeholder="Escreva uma mensagem fraterna para todos os Irmãos..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          className="w-full bg-[#080D18] text-white p-3 rounded-xl border border-slate-700 focus:border-[#D4AF37] text-xs"
        />
        <div className="flex justify-end">
          <button
            type="submit"
            className="flex items-center space-x-1.5 bg-[#D4AF37] hover:bg-[#C5A028] text-slate-950 font-bold px-4 py-2 rounded-xl text-xs uppercase tracking-wider transition-all shadow-[0_0_15px_rgba(212,175,55,0.25)]"
          >
            <Send className="w-3.5 h-3.5" />
            <span>Publicar Comunicado</span>
          </button>
        </div>
      </form>

      {/* Message Feed */}
      <div className="space-y-4">
        {messages.map((m) => (
          <div 
            key={m.id} 
            className={`luxury-card p-5 space-y-2 border ${
              m.important ? "border-amber-500/40 bg-gradient-to-r from-amber-500/5 to-transparent" : "border-slate-800"
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2.5">
                <div className="w-8 h-8 rounded-full bg-[#D4AF37]/20 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] text-xs font-bold font-serif">
                  {m.sender.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-sm text-white">{m.sender}</h4>
                  <span className="text-[10px] text-[#D4AF37] font-mono">{m.role}</span>
                </div>
              </div>

              <span className="text-[10px] text-slate-500 font-mono">{m.date}</span>
            </div>

            <p className="text-xs text-slate-300 leading-relaxed pl-10">
              {m.content}
            </p>
          </div>
        ))}
      </div>

    </div>
  );
};
